import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIndia = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_6545_10389)",
		children: /* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_6545_10389)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					width: 24,
					height: 24,
					rx: 12,
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M-6 0H30V8H-6V0Z",
					fill: "#FF6820"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M-6 16H30V24H-6V16Z",
					fill: "#046A38"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12 15.7C14.0435 15.7 15.7 14.0434 15.7 12C15.7 9.95653 14.0435 8.29999 12 8.29999C9.9566 8.29999 8.30005 9.95653 8.30005 12C8.30005 14.0434 9.9566 15.7 12 15.7Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12 15.2C13.7674 15.2 15.2 13.7673 15.2 12C15.2 10.2327 13.7674 8.79999 12 8.79999C10.2327 8.79999 8.80005 10.2327 8.80005 12C8.80005 13.7673 10.2327 15.2 12 15.2Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.0001 12.64C12.3536 12.64 12.6401 12.3534 12.6401 12C12.6401 11.6465 12.3536 11.36 12.0001 11.36C11.6466 11.36 11.3601 11.6465 11.3601 12C11.3601 12.3534 11.6466 12.64 12.0001 12.64Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11.9999 8.80002L12.1199 10.7257L11.9999 11.6791L11.8799 10.7257L11.9999 8.80002Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.3994 8.9662C12.476 8.97629 12.5464 8.92233 12.5565 8.84567C12.5665 8.76901 12.5126 8.69868 12.4359 8.68859C12.3593 8.6785 12.2889 8.73246 12.2788 8.80912C12.2688 8.88578 12.3227 8.9561 12.3994 8.9662Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.0001 15.2L11.8801 13.2744L12.0001 12.321L12.1201 13.2744L12.0001 15.2Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11.6006 15.0339C11.524 15.0238 11.4536 15.0777 11.4435 15.1544C11.4335 15.2311 11.4874 15.3014 11.5641 15.3115C11.6407 15.3216 11.7111 15.2676 11.7212 15.1909C11.7312 15.1143 11.6773 15.044 11.6006 15.0339Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.8283 8.90908L12.4458 10.8002L12.0832 11.69L12.214 10.738L12.8283 8.90908Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.1711 9.17295C13.2426 9.20254 13.3244 9.16862 13.354 9.09718C13.3836 9.02575 13.3497 8.94385 13.2783 8.91426C13.2068 8.88467 13.1249 8.9186 13.0954 8.99003C13.0658 9.06146 13.0997 9.14336 13.1711 9.17295Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11.1717 15.091L11.5542 13.1999L11.9168 12.3101L11.786 13.262L11.1717 15.091Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.8289 14.8271C10.7574 14.7975 10.6756 14.8314 10.646 14.9029C10.6164 14.9743 10.6503 15.0562 10.7217 15.0858C10.7932 15.1154 10.8751 15.0815 10.9046 15.01C10.9342 14.9386 10.9003 14.8567 10.8289 14.8271Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.6 9.22882L12.7411 10.9565L12.1605 11.7222L12.5333 10.8365L13.6 9.22882Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.8627 9.57244C13.9241 9.61951 14.012 9.60794 14.059 9.5466C14.1061 9.48526 14.0945 9.39737 14.0332 9.3503C13.9718 9.30323 13.884 9.3148 13.8369 9.37615C13.7898 9.43749 13.8014 9.52537 13.8627 9.57244Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.4 14.7714L11.2589 13.0437L11.8395 12.2781L11.4667 13.1637L10.4 14.7714Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.1373 14.4277C10.0759 14.3807 9.98804 14.3922 9.94097 14.4536C9.8939 14.5149 9.90547 14.6028 9.96681 14.6499C10.0282 14.697 10.116 14.6854 10.1631 14.624C10.2102 14.5627 10.1986 14.4748 10.1373 14.4277Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.2628 9.73735L12.9861 11.1838L12.227 11.7732L12.8163 11.0141L14.2628 9.73735Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.4275 10.1373C14.4746 10.1986 14.5625 10.2102 14.6238 10.1631C14.6852 10.116 14.6967 10.0282 14.6497 9.96681C14.6026 9.90547 14.5147 9.8939 14.4534 9.94097C14.392 9.98804 14.3805 10.0759 14.4275 10.1373Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.73717 14.2628L11.0139 12.8163L11.773 12.227L11.1837 12.986L9.73717 14.2628Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.57246 13.8629C9.52539 13.8015 9.43751 13.7899 9.37616 13.837C9.31482 13.8841 9.30325 13.972 9.35032 14.0333C9.39739 14.0947 9.48527 14.1062 9.54662 14.0592C9.60796 14.0121 9.61953 13.9242 9.57246 13.8629Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.7712 10.4001L13.1635 11.4668L12.2778 11.8396L13.0435 11.259L14.7712 10.4001Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.8271 10.8291C14.8567 10.9005 14.9386 10.9344 15.01 10.9049C15.0815 10.8753 15.1154 10.7934 15.0858 10.7219C15.0562 10.6505 14.9743 10.6166 14.9029 10.6462C14.8314 10.6758 14.7975 10.7577 14.8271 10.8291Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.22882 13.6L10.8365 12.5333L11.7222 12.1605L10.9565 12.7411L9.22882 13.6Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.17288 13.171C9.1433 13.0996 9.0614 13.0657 8.98997 13.0953C8.91853 13.1249 8.88461 13.2068 8.9142 13.2782C8.94379 13.3496 9.02568 13.3835 9.09712 13.354C9.16855 13.3244 9.20247 13.2425 9.17288 13.171Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.0909 11.1718L13.2619 11.7862L12.3099 11.917L13.1998 11.5543L15.0909 11.1718Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.0339 11.6006C15.044 11.6773 15.1143 11.7313 15.191 11.7212C15.2676 11.7111 15.3216 11.6408 15.3115 11.5641C15.3014 11.4874 15.2311 11.4335 15.1544 11.4436C15.0778 11.4537 15.0238 11.524 15.0339 11.6006Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.90913 12.8283L10.7381 12.214L11.6901 12.0832L10.8002 12.4459L8.90913 12.8283Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.96612 12.3995C8.95603 12.3229 8.8857 12.2689 8.80904 12.279C8.73238 12.2891 8.67842 12.3594 8.68851 12.4361C8.69861 12.5127 8.76893 12.5667 8.84559 12.5566C8.92225 12.5465 8.97621 12.4762 8.96612 12.3995Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.2 12L13.2743 12.12L12.3209 12L13.2743 11.88L15.2 12Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.0337 12.3994C15.0236 12.4761 15.0776 12.5464 15.1542 12.5565C15.2309 12.5666 15.3012 12.5126 15.3113 12.436C15.3214 12.3593 15.2674 12.289 15.1908 12.2789C15.1141 12.2688 15.0438 12.3227 15.0337 12.3994Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.80005 12L10.7257 11.88L11.6791 12L10.7257 12.12L8.80005 12Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.96629 11.6006C8.97638 11.5239 8.92242 11.4536 8.84576 11.4435C8.7691 11.4334 8.69878 11.4874 8.68868 11.564C8.67859 11.6407 8.73255 11.711 8.80921 11.7211C8.88587 11.7312 8.9562 11.6773 8.96629 11.6006Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.091 12.8283L13.1999 12.4458L12.3101 12.0831L13.262 12.214L15.091 12.8283Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.8271 13.1711C14.7976 13.2425 14.8315 13.3244 14.9029 13.354C14.9743 13.3836 15.0562 13.3496 15.0858 13.2782C15.1154 13.2068 15.0815 13.1249 15.0101 13.0953C14.9386 13.0657 14.8567 13.0996 14.8271 13.1711Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.90899 11.1718L10.8001 11.5543L11.6899 11.9169L10.738 11.7861L8.90899 11.1718Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.17286 10.829C9.20245 10.7575 9.16852 10.6756 9.09709 10.6461C9.02566 10.6165 8.94376 10.6504 8.91417 10.7218C8.88458 10.7933 8.9185 10.8752 8.98994 10.9047C9.06137 10.9343 9.14327 10.9004 9.17286 10.829Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.7713 13.6L13.0436 12.7411L12.278 12.1605L13.1636 12.5333L14.7713 13.6Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.4277 13.8628C14.3807 13.9242 14.3922 14.0121 14.4536 14.0591C14.5149 14.1062 14.6028 14.0946 14.6499 14.0333C14.697 13.9719 14.6854 13.8841 14.624 13.837C14.5627 13.7899 14.4748 13.8015 14.4277 13.8628Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.2287 10.4L10.9564 11.2589L11.722 11.8395L10.8364 11.4668L9.2287 10.4Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.57226 10.1372C9.61933 10.0759 9.60776 9.98798 9.54642 9.94091C9.48507 9.89384 9.39719 9.90541 9.35012 9.96675C9.30305 10.0281 9.31462 10.116 9.37596 10.163C9.4373 10.2101 9.52519 10.1985 9.57226 10.1372Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.2628 14.2628L12.8163 12.986L12.227 12.227L12.986 12.8163L14.2628 14.2628Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.8628 14.4277C13.8014 14.4748 13.7899 14.5626 13.8369 14.624C13.884 14.6853 13.9719 14.6969 14.0332 14.6498C14.0946 14.6028 14.1061 14.5149 14.0591 14.4535C14.012 14.3922 13.9241 14.3806 13.8628 14.4277Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.7372 9.73741L11.1837 11.0142L11.773 11.7732L11.014 11.1839L9.7372 9.73741Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.1372 9.57249C10.1986 9.52542 10.2101 9.43754 10.1631 9.37619C10.116 9.31485 10.0281 9.30328 9.96678 9.35035C9.90544 9.39742 9.89387 9.48531 9.94094 9.54665C9.98801 9.60799 10.0759 9.61956 10.1372 9.57249Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.5999 14.7713L12.5332 13.1637L12.1604 12.278L12.741 13.0437L13.5999 14.7713Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.171 14.8271C13.0995 14.8567 13.0656 14.9386 13.0952 15.01C13.1248 15.0815 13.2067 15.1154 13.2781 15.0858C13.3496 15.0562 13.3835 14.9743 13.3539 14.9029C13.3243 14.8314 13.2424 14.7975 13.171 14.8271Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.4001 9.22876L11.4668 10.8364L11.8396 11.7221L11.259 10.9564L10.4001 9.22876Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.829 9.17295C10.9005 9.14336 10.9344 9.06146 10.9048 8.99003C10.8752 8.91859 10.7933 8.88467 10.7219 8.91426C10.6504 8.94385 10.6165 9.02574 10.6461 9.09718C10.6757 9.16861 10.7576 9.20253 10.829 9.17295Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.8282 15.0909L12.2139 13.262L12.083 12.31L12.4457 13.1999L12.8282 15.0909Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.3994 15.0338C12.3227 15.0439 12.2687 15.1142 12.2788 15.1909C12.2889 15.2675 12.3592 15.3215 12.4359 15.3114C12.5126 15.3013 12.5665 15.231 12.5564 15.1543C12.5463 15.0777 12.476 15.0237 12.3994 15.0338Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11.1718 8.90901L11.7861 10.738L11.917 11.69L11.5543 10.8001L11.1718 8.90901Z",
					fill: "#07038D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11.6006 8.96615C11.6773 8.95606 11.7313 8.88573 11.7212 8.80907C11.7111 8.73241 11.6408 8.67845 11.5641 8.68854C11.4874 8.69864 11.4335 8.76896 11.4436 8.84562C11.4537 8.92228 11.524 8.97624 11.6006 8.96615Z",
					fill: "#07038D"
				})
			]
		})
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_6545_10389",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip1_6545_10389",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			rx: 12,
			fill: "white"
		})
	})] })]
});
export { SvgIndia as ReactComponent };
